import { window } from "global";
import { useEffect } from "react";
import { MediaQuery } from "@outplayed/responsive";
import { TierListHeader } from "../../TierListHeader";
import { TierListPageNav } from "../../TierListPageNav";
import { TierListFilterManager } from "../../TierListFilterManager";
import { TierListTable } from "./TierListTable";
import { TierListTablePlaceholder } from "../../common/TierListTablePlaceholder";
import { TierListTableError } from "../../common/TierListTableError";

import { selectWinRate } from "@ugg/shared/api/data-parser/tier-lists/tier-list";
import { useValidateQueryParams } from "@ugg/shared/query-params/params-helpers";
import { validParams } from "@ugg/shared/query-params/valid-params";
import { useQueryString } from "@ugg/shared/hooks/use-query-string";
import { useTierList } from "@ugg/shared/api/requests/tier-lists/tier-list";
import { useTierListPage } from "@ugg/shared/pages/tier-list-pages";

type BannerProp = {
  bannerSlot?: JSX.Element | null;
};

export const TierList = ({ bannerSlot }: BannerProp) => {
  const queryParams = useQueryString();
  const page = useTierListPage();
  const validateQueryParams = useValidateQueryParams(validParams);
  const { data, loading, error } = useTierList(page, { params: queryParams, ssr: true });

  useEffect(() => {
    window && window.scrollTo(0, 0);
  }, []);

  const validatedParams = validateQueryParams(page, queryParams, true);
  const filters = { ...validatedParams };
  const { role_win_rates, last_updated, total_matches_count } = selectWinRate(data, filters);

  let table = null;
  if (!window) {
    table = null;
  } else if (loading) {
    table = <TierListTablePlaceholder />;
  } else if (error) {
    table = <TierListTableError />;
  } else {
    table = <TierListTable filters={filters} data={role_win_rates || []} />;
  }

  return (
    <div>
      <TierListHeader
        className="mb-[24px]"
        totalMatches={total_matches_count}
        lastUpdated={last_updated}
        loading={loading}
        includeMeta
      />
      <MediaQuery min="TABLET" max="DESKTOP_LARGE">
        <div>
          <TierListPageNav />
        </div>
      </MediaQuery>
      {bannerSlot ?? null}
      <TierListFilterManager className="my-[24px]" />
      {table}
    </div>
  );
};
